(() => {
  'use strict';


  /* =========================================================
   COTTON HUB - LANGUAGE TRANSLATIONS
   ========================================================= */

const isArabic = document.documentElement.lang
  .toLowerCase()
  .startsWith('ar');

const REC_TEXT = {
  addToCart: isArabic ? '+ أضف للسلة' : '+ Add to Cart',
  adding: isArabic ? 'جاري الإضافة...' : 'Adding...',
  error: isArabic
    ? 'حصلت مشكلة أثناء إضافة المنتج للسلة. حاول مرة أخرى.'
    : 'Something went wrong while adding the product to your cart. Please try again.'
};

  /* =========================================================
     Cotton Hub - Cart Drawer Recommendations FINAL V3
     ========================================================= */


  /* =========================================================
     1. CONFIG
     ========================================================= */

  const CONFIG = {

    recommendationsLimit: 4,

    /*
      "related" = منتجات مرتبطة بالمنتج الموجود في السلة.
      يمكن تغييرها لاحقًا إلى "complementary"
      بعد ضبط Complementary Recommendations في Shopify.
    */
    recommendationIntent: 'related',

    cartContainerId: 'CartDrawer-Recommendations',

    cartItemsId: 'CartDrawer-CartItems',

    freeDeliveryId: 'cart-page-free-delivery',

    /*
      Selectors مرنة لعداد السلة.
    */
    cartCountSelectors: [
      '[data-cart-count]',
      '[data-cart-items-count]',
      '.cart-count',
      '.cart-count-bubble [aria-hidden="true"]',
      '.cart-count-bubble > span:not(.visually-hidden)',
      '#cart-icon-bubble [aria-hidden="true"]',
      'cart-icon-bubble [aria-hidden="true"]'
    ]
  };


  /* =========================================================
     2. GLOBAL STATE
     ========================================================= */

  let recommendationsRequestId = 0;

  let cartDrawerRefreshInProgress = false;

  let recommendationsDebounceTimer = null;

  let cartDrawerRefreshTimer = null;

  let cartObserver = null;

  let observedCartItems = null;

  let isInitialized = false;


  /* =========================================================
     4. SHOPIFY URL HELPER
     ========================================================= */

  function shopifyUrl(path) {

    const root =
      window.Shopify?.routes?.root || '/';

    return (
      root +
      String(path || '')
        .replace(/^\/+/, '')
    );
  }


  /* =========================================================
     5. JSON RESPONSE HELPER
     ========================================================= */

  async function parseJsonResponse(response) {

    let data = null;

    try {
      data = await response.json();
    } catch (error) {

      if (!response.ok) {

        const requestError =
          new Error(
            `Shopify request failed: ${response.status}`
          );

        requestError.status =
          response.status;

        throw requestError;
      }

      throw error;
    }


    if (!response.ok) {

      const requestError =
        new Error(
          data?.description ||
          data?.message ||
          'Shopify request failed'
        );

      requestError.status =
        response.status;

      requestError.data =
        data;

      throw requestError;
    }


    return data;
  }


  /* =========================================================
     6. HTML ESCAPE
     ========================================================= */

  function escapeHTML(value) {

    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }


  /* =========================================================
     7. GET RECOMMENDATIONS CONTAINER
     ========================================================= */

  function getCartContainer() {

    return document.getElementById(
      CONFIG.cartContainerId
    );
  }


  /* =========================================================
     8. GET VARIANT SIZE
     ========================================================= */

  function getVariantSize(product, variant) {

    /*
      نحاول أولاً استخدام اسم الـOption الحقيقي
      بدل الاعتماد على split().
    */

    if (Array.isArray(product?.options)) {

      const sizeIndex =
        product.options.findIndex(option => {

          const name =
            String(option || '')
              .trim()
              .toLowerCase();

          return [
            'size',
            'مقاس',
            'المقاس',
            'age',
            'العمر',
            'سن'
          ].some(keyword => {

            return name === keyword;
          });

        });


      if (sizeIndex !== -1) {

        const optionValue =
          variant?.[`option${sizeIndex + 1}`];

        if (optionValue) {
          return optionValue;
        }
      }
    }


    /*
      Fallback
    */

    if (variant?.title) {

      if (variant.title.includes('/')) {

        return variant.title
          .split('/')[0]
          .trim();
      }

      return variant.title.trim();
    }


    return '';
  }


  /* =========================================================
     9. GET VARIANT IMAGE
     ========================================================= */

  function getVariantImage(product, variant) {

    if (
      variant?.featured_image &&
      variant.featured_image.src
    ) {

      return variant.featured_image.src;
    }

    return product?.images?.[0] || '';
  }


  /* =========================================================
     10. GET VARIANT PRICE
     ========================================================= */

  function getVariantPrice(product, variant) {

    if (
      typeof variant?.price === 'number'
    ) {

      return variant.price;
    }

    if (
      typeof product?.price === 'number'
    ) {

      return product.price;
    }

    return 0;
  }


  /* =========================================================
     11. MONEY FORMAT
     ========================================================= */

  function formatMoneyFromCents(cents) {

    const amount =
      Number(cents || 0) / 100;

    return (
      new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 0
      }).format(amount) +
      ' EGP'
    );
  }


  /* =========================================================
     12. UPDATE CART ICON COUNT
     ========================================================= */

  function updateCartIconCount(itemCount) {

    const count =
      Number(itemCount || 0);

    const elements =
      new Set();


    CONFIG.cartCountSelectors
      .forEach(selector => {

        try {

          document
            .querySelectorAll(selector)
            .forEach(el => {

              elements.add(el);

            });

        } catch (error) {

          console.warn(
            'Invalid cart counter selector:',
            selector,
            error
          );

        }

      });


    elements.forEach(el => {

      if (
        el.hasAttribute(
          'data-cart-count'
        )
      ) {

        el.setAttribute(
          'data-cart-count',
          String(count)
        );
      }


      if (
        el.hasAttribute(
          'data-cart-items-count'
        )
      ) {

        el.setAttribute(
          'data-cart-items-count',
          String(count)
        );
      }


      /*
        تحديث الرقم.
      */
      el.textContent =
        count > 0
          ? String(count)
          : '';


      /*
        التعامل مع Bubble.
      */
      const bubble =
        el.closest(
          '.cart-count-bubble'
        ) ||
        el.closest(
          'cart-icon-bubble'
        );


      if (bubble) {

        if (count > 0) {

          bubble.classList.remove(
            'hidden'
          );

          bubble.style.display = '';

        } else {

          bubble.classList.add(
            'hidden'
          );

          bubble.style.display =
            'none';
        }
      }

    });


    /*
      Accessibility labels
    */

    document
      .querySelectorAll(
        '[data-cart-label], [aria-label*="cart" i], [aria-label*="السلة"]'
      )
      .forEach(el => {

        const currentLabel =
          el.getAttribute(
            'aria-label'
          );

        if (!currentLabel) return;


        if (
          currentLabel
            .toLowerCase()
            .includes('cart') ||
          currentLabel.includes(
            'السلة'
          )
        ) {

          const label =
            count === 1
              ? 'Cart, 1 item'
              : `Cart, ${count} items`;


          el.setAttribute(
            'aria-label',
            label
          );
        }
      });

  }


  /* =========================================================
     13. GET CURRENT CART
     ========================================================= */

  async function getCart() {

    const response =
      await fetch(
        shopifyUrl('cart.js'),
        {
          method: 'GET',

          headers: {
            'Accept':
              'application/json'
          },

          credentials:
            'same-origin',

          cache:
            'no-store'
        }
      );


    return parseJsonResponse(
      response
    );
  }


  /* =========================================================
     14. CLOSE ALL DROPDOWNS
     ========================================================= */

  function closeAllRecommendationDropdowns() {

    document
      .querySelectorAll(
        '[id^="dropdown-options-"]'
      )
      .forEach(dropdown => {

        dropdown.style.display =
          'none';

      });
  }


  /* =========================================================
     15. TOGGLE DROPDOWN
     ========================================================= */

  function toggleRecDropdown(productId) {

    const dropdown =
      document.getElementById(
        `dropdown-options-${productId}`
      );


    if (!dropdown) return;


    const isOpen =
      dropdown.style.display ===
      'block';


    closeAllRecommendationDropdowns();


    if (!isOpen) {

      dropdown.style.display =
        'block';
    }
  }


  /* =========================================================
     16. SELECT VARIANT
     ========================================================= */

  function selectRecVariant(
    productId,
    variantId,
    sizeText,
    imgUrl
  ) {

    const input =
      document.getElementById(
        `rec-variant-${productId}`
      );


    const selectedText =
      document.getElementById(
        `selected-text-${productId}`
      );


    const selectedImg =
      document.getElementById(
        `selected-img-${productId}`
      );


    const dropdown =
      document.getElementById(
        `dropdown-options-${productId}`
      );


    if (input) {

      input.value =
        variantId;
    }


    if (selectedText) {

      selectedText.textContent =
        sizeText;
    }


    if (selectedImg) {

      selectedImg.src =
        imgUrl;
    }


    if (dropdown) {

      dropdown.style.display =
        'none';
    }


    const mainImg =
      document.getElementById(
        `rec-img-${productId}`
      );


    if (mainImg) {

      mainImg.style.opacity =
        '0.3';


      setTimeout(() => {

        mainImg.src =
          imgUrl;

        mainImg.style.opacity =
          '1';

      }, 120);
    }

  }


  /* =========================================================
     17. LOAD RECOMMENDATIONS
     ========================================================= */

  async function loadCartDrawerRecommendations() {

    const container =
      getCartContainer();


    if (!container) {
      return;
    }


    const requestId =
      ++recommendationsRequestId;


    try {

      const cart =
        await getCart();


      /*
        تحديث Cart Icon
      */

      updateCartIconCount(
        cart.item_count
      );


      /*
        لو السلة فاضية
      */

      if (
        !cart.items ||
        cart.items.length === 0
      ) {

        container.style.display =
          'none';

        return;
      }


      /*
        أول منتج في السلة
      */

      const productId =
        cart.items[0]
          .product_id;


      const params =
        new URLSearchParams({
          product_id:
            String(productId),

          limit:
            String(
              CONFIG.recommendationsLimit
            ),

          intent:
            CONFIG.recommendationIntent
        });


      const response =
        await fetch(
          shopifyUrl(
            `recommendations/products.json?${params.toString()}`
          ),
          {
            method: 'GET',

            headers: {
              'Accept':
                'application/json'
            },

            credentials:
              'same-origin',

            cache:
              'no-store'
          }
        );


      const data =
        await parseJsonResponse(
          response
        );


      /*
        تجاهل Response قديم
        لو فيه Request أحدث منه.
      */

      if (
        requestId !==
        recommendationsRequestId
      ) {

        return;
      }


      /*
        مفيش Recommendations
      */

      if (
        !data ||
        !Array.isArray(
          data.products
        ) ||
        data.products.length === 0
      ) {

        container.style.display =
          'none';

        return;
      }


      const list =
        container.querySelector(
          '.recommendations-container'
        );


      if (!list) {
        return;
      }


      /*
        تفريغ القديم
      */

      list.innerHTML = '';


      /*
        إظهار القسم
      */

      container.style.display =
        'block';


      /*
        إنشاء المنتجات
      */

      data.products.forEach(
        product => {

          if (
            !product?.variants?.length
          ) {
            return;
          }


          /*
            الـVariants المتاحة فقط
          */

          const availableVariants =
            product.variants
              .filter(
                variant =>
                  variant.available
              );


          const variantsToUse =
            availableVariants.length
              ? availableVariants
              : [product.variants[0]];


          /*
            أول Variant
          */

          const firstAvailable =
            variantsToUse[0];


          /*
            أول صورة
          */

          const firstImage =
            getVariantImage(
              product,
              firstAvailable
            );


          /*
            أول مقاس
          */

          const firstSize =
            getVariantSize(
              product,
              firstAvailable
            );


          /*
            أول سعر
          */

          const firstVariantPrice =
            getVariantPrice(
              product,
              firstAvailable
            );


          let variantHTML = '';


/* =================================================
   VARIANTS / SIZE SELECTOR
   ================================================= */

const hasMeaningfulVariant =
  firstAvailable &&
  firstSize &&
  firstSize !== 'Default Title';


if (hasMeaningfulVariant) {

  let optionsList = '';


  variantsToUse.forEach(
    variant => {

      const variantImage =
        getVariantImage(
          product,
          variant
        );


      const variantSize =
        getVariantSize(
          product,
          variant
        );


      const variantPrice =
        getVariantPrice(
          product,
          variant
        );


      optionsList += `

        <div
          class="cottonhub-rec-variant"
          data-product-id="${escapeHTML(product.id)}"
          data-variant-id="${escapeHTML(variant.id)}"
          data-size="${escapeHTML(variantSize)}"
          data-image="${escapeHTML(variantImage)}"
          data-price="${escapeHTML(variantPrice)}"
        >

          <span class="cottonhub-rec-variant-size">
            ${escapeHTML(variantSize)}
          </span>

          <img
            src="${escapeHTML(variantImage)}"
            class="cottonhub-rec-variant-image"
            alt=""
            loading="lazy"
          >

        </div>

      `;
    }
  );


  variantHTML = `

    <div
      class="cottonhub-rec-select"
      id="custom-select-${escapeHTML(product.id)}"
    >

      <div
        class="cottonhub-rec-select-trigger"
        data-product-id="${escapeHTML(product.id)}"
      >

        <span
          id="selected-text-${escapeHTML(product.id)}"
          class="cottonhub-rec-selected-text"
        >
          ${escapeHTML(firstSize)}
        </span>

        <div class="cottonhub-rec-select-right">

          <img
            id="selected-img-${escapeHTML(product.id)}"
            src="${escapeHTML(firstImage)}"
            class="cottonhub-rec-selected-image"
            alt=""
          >

          <span class="cottonhub-rec-chevron">
            ▼
          </span>

        </div>

      </div>


      <div
        id="dropdown-options-${escapeHTML(product.id)}"
        class="modern-scroll cottonhub-rec-dropdown"
      >
        ${optionsList}
      </div>


      <input
        type="hidden"
        id="rec-variant-${escapeHTML(product.id)}"
        value="${escapeHTML(firstAvailable.id)}"
        data-price="${escapeHTML(firstVariantPrice)}"
      >

    </div>

  `;

} else {

  variantHTML = `

    <input
      type="hidden"
      id="rec-variant-${escapeHTML(product.id)}"
      value="${escapeHTML(firstAvailable.id)}"
      data-price="${escapeHTML(firstVariantPrice)}"
    >

  `;
}

          /*
            السعر
          */

          const currentPrice =
            formatMoneyFromCents(
              firstVariantPrice
            );


          /* =================================================
             PRODUCT CARD
             ================================================= */

const itemHTML = `

  <div
    class="cottonhub-recommendation-card"
    data-product-id="${escapeHTML(product.id)}"
  >

    <a
      href="${escapeHTML(product.url)}"
      class="cottonhub-rec-image-link"
    >

      <img
        id="rec-img-${escapeHTML(product.id)}"
        src="${escapeHTML(firstImage)}"
        class="cottonhub-rec-main-image"
        alt="${escapeHTML(product.title)}"
        loading="lazy"
      >

    </a>


    <p class="cottonhub-rec-title">
      ${escapeHTML(product.title)}
    </p>


    <p
      id="rec-price-${escapeHTML(product.id)}"
      class="cottonhub-rec-price"
    >
      ${currentPrice}
    </p>


    <div class="cottonhub-rec-bottom">

      ${variantHTML}


      <button
        type="button"
        class="cottonhub-rec-button"
        data-product-id="${escapeHTML(product.id)}"
      >
${REC_TEXT.addToCart}
</button>

    </div>

  </div>

`;


          /*
            إضافة الكارت
          */

          list.insertAdjacentHTML(
            'beforeend',
            itemHTML
          );

        }
      );


    } catch (error) {

      console.error(
        'Cotton Hub recommendations error:',
        error
      );

      /*
        لا نعمل Reload للصفحة
        بسبب خطأ Recommendations.
      */

    }

  }


  /* =========================================================
     18. UPDATE SHOPIFY SECTION
     ========================================================= */

  function updateSectionFromResponse(
    sectionHTML
  ) {

    if (!sectionHTML) {
      return;
    }


    const wrapper =
      document.createElement('div');


    wrapper.innerHTML =
      sectionHTML.trim();


    const incomingBubble =
      wrapper.querySelector(
        '#shopify-section-cart-icon-bubble'
      ) ||
      wrapper.querySelector(
        'cart-icon-bubble'
      ) ||
      wrapper.querySelector(
        '.cart-count-bubble'
      );


    if (!incomingBubble) {
      return;
    }


    const currentBubble =
      document.querySelector(
        '#shopify-section-cart-icon-bubble'
      ) ||
      document.querySelector(
        'cart-icon-bubble'
      );


    if (currentBubble) {

      currentBubble.replaceWith(
        incomingBubble
      );
    }

  }


  /* =========================================================
     19. REFRESH CUSTOM CART DRAWER
     ========================================================= */

  async function refreshCustomCartDrawer() {

    if (
      cartDrawerRefreshInProgress
    ) {
      return;
    }


    const currentItems =
      document.getElementById(
        CONFIG.cartItemsId
      );


    if (!currentItems) {
      return;
    }


    cartDrawerRefreshInProgress =
      true;


    try {

      /*
        نجيب النسخة الحديثة من الصفحة
      */

      const response =
        await fetch(
          window.location.href,
          {
            method:
              'GET',

            headers: {
              'Accept':
                'text/html'
            },

            credentials:
              'same-origin',

            cache:
              'no-store'
          }
        );


      if (!response.ok) {

        throw new Error(
          `Cart drawer refresh failed: ${response.status}`
        );
      }


      const html =
        await response.text();


      const parser =
        new DOMParser();


      const doc =
        parser.parseFromString(
          html,
          'text/html'
        );


      /*
        Cart Items
      */

      const newItems =
        doc.getElementById(
          CONFIG.cartItemsId
        );


      if (
        currentItems &&
        newItems
      ) {

        currentItems.innerHTML =
          newItems.innerHTML;
      }


      /*
        Subtotal
      */

      const currentSubtotal =
        document.querySelector(
          '.totals__subtotal-value'
        );


      const newSubtotal =
        doc.querySelector(
          '.totals__subtotal-value'
        );


      if (
        currentSubtotal &&
        newSubtotal
      ) {

        currentSubtotal.innerHTML =
          newSubtotal.innerHTML;
      }


      /*
        Free Delivery
      */

      const currentDelivery =
        document.getElementById(
          CONFIG.freeDeliveryId
        );


      const newDelivery =
        doc.getElementById(
          CONFIG.freeDeliveryId
        );


      if (
        currentDelivery &&
        newDelivery
      ) {

        currentDelivery.innerHTML =
          newDelivery.innerHTML;
      }


    } catch (error) {

      console.error(
        'Custom cart drawer refresh error:',
        error
      );

    } finally {

      cartDrawerRefreshInProgress =
        false;
    }

  }


  /* =========================================================
     20. ADD RECOMMENDED ITEM
     ========================================================= */

  async function addRecommendedItem(
    productId
  ) {

    const variantInput =
      document.getElementById(
        `rec-variant-${productId}`
      );


    if (!variantInput) {
      return;
    }


    const variantId =
      Number(
        variantInput.value
      );


    if (!variantId) {

      console.error(
        'No valid variant selected.'
      );

      return;
    }


    const button =
      document.querySelector(
        `.cottonhub-rec-button[data-product-id="${CSS.escape(String(productId))}"]`
      );


    const recommendationsContainer =
      getCartContainer();


    /*
      UI loading
    */

    if (button) {

      button.disabled =
        true;

      button.style.opacity =
        '0.5';

      button.textContent =
  REC_TEXT.adding;
    }


    if (
      recommendationsContainer
    ) {

      recommendationsContainer.style.opacity =
        '0.6';
    }


    try {

      /*
        Shopify Bundled Section Rendering
      */

      const payload = {

        items: [
          {
            id:
              variantId,

            quantity:
              1
          }
        ],

        sections: [
          'cart-items',
          'cart-icon-bubble',
          'cart-live-region-text',
          'cart-footer'
        ],

        sections_url:
          window.location.pathname ||
          '/cart'
      };


      const response =
        await fetch(
          shopifyUrl(
            'cart/add.js'
          ),
          {
            method:
              'POST',

            headers: {
              'Content-Type':
                'application/json',

              'Accept':
                'application/json'
            },

            credentials:
              'same-origin',

            body:
              JSON.stringify(
                payload
              )
          }
        );


      const result =
        await parseJsonResponse(
          response
        );


      /*
        تحديث Cart Icon
      */

      if (
        typeof result.item_count !==
        'undefined'
      ) {

        updateCartIconCount(
          result.item_count
        );
      }


      /*
        تحديث Section لو متاح
      */

      if (result.sections) {

        updateSectionFromResponse(
          result.sections[
            'cart-icon-bubble'
          ]
        );


        updateSectionFromResponse(
          result.sections[
            'cart-live-region-text'
          ]
        );
      }


      /*
        تحديث Cart Drawer
      */

      await refreshCustomCartDrawer();


      /*
        تحديث Recommendations
      */

      await loadCartDrawerRecommendations();


      /*
        Event
      */

      document.dispatchEvent(
        new CustomEvent(
          'cottonhub:cart-updated',
          {
            detail: {
              cart:
                result
            }
          }
        )
      );


    } catch (error) {

      console.error(
        'Cotton Hub add-to-cart error:',
        error
      );


      alert(
  error?.data?.description ||
  error?.data?.message ||
  REC_TEXT.error
);


    } finally {

      if (button) {

        button.disabled =
          false;

        button.style.opacity =
          '1';

        button.textContent =
  REC_TEXT.addToCart;
      }


      if (
        recommendationsContainer
      ) {

        recommendationsContainer.style.opacity =
          '1';
      }

    }

  }


  /* =========================================================
     21. EVENT DELEGATION
     ========================================================= */

  document.addEventListener(
    'click',
    event => {

      /*
        Add Recommendation
      */

      const addButton =
        event.target.closest(
          '.cottonhub-rec-button'
        );


      if (addButton) {

        const productId =
          addButton.dataset.productId;


        if (productId) {

          addRecommendedItem(
            productId
          );
        }


        return;
      }


      /*
        Dropdown trigger
      */

      const dropdownTrigger =
        event.target.closest(
          '.cottonhub-rec-select-trigger'
        );


      if (dropdownTrigger) {

        const productId =
          dropdownTrigger.dataset.productId;


        if (productId) {

          toggleRecDropdown(
            productId
          );
        }


        return;
      }


      /*
        Variant selection
      */

      const variantOption =
        event.target.closest(
          '.cottonhub-rec-variant'
        );


      if (variantOption) {

        const productId =
          variantOption.dataset.productId;


        const variantId =
          variantOption.dataset.variantId;


        const size =
          variantOption.dataset.size ||
          '';


        const img =
          variantOption.dataset.image ||
          '';


        const input =
          document.getElementById(
            `rec-variant-${productId}`
          );


        if (input) {

          input.value =
            variantId;


          input.dataset.price =
            variantOption.dataset.price ||
            '';
        }


        const priceElement =
          document.getElementById(
            `rec-price-${productId}`
          );


        if (priceElement) {

          const variantPrice =
            Number(
              variantOption.dataset.price ||
              0
            );


          priceElement.textContent =
            formatMoneyFromCents(
              variantPrice
            );
        }


        selectRecVariant(
          productId,
          variantId,
          size,
          img
        );


        return;
      }


      /*
        Close dropdown outside
      */

      if (
        !event.target.closest(
          '[id^="custom-select-"]'
        )
      ) {

        closeAllRecommendationDropdowns();
      }

    }
  );


  /* =========================================================
     22. EVENTS FROM THEME / APPS
     ========================================================= */

  function scheduleRecommendationsRefresh() {

    clearTimeout(
      recommendationsDebounceTimer
    );


    recommendationsDebounceTimer =
      setTimeout(() => {

        loadCartDrawerRecommendations();

      }, 250);
  }


  document.addEventListener(
    'cart:updated',
    scheduleRecommendationsRefresh
  );


  document.addEventListener(
    'cart:change',
    scheduleRecommendationsRefresh
  );


  document.addEventListener(
    'cart:refresh',
    scheduleRecommendationsRefresh
  );


  document.addEventListener(
    'cottonhub:cart-updated',
    scheduleRecommendationsRefresh
  );


  /* =========================================================
     23. ROBUST CART DRAWER OBSERVER
     ========================================================= */

  function refreshRecommendationsAfterCartChange() {

    clearTimeout(
      cartDrawerRefreshTimer
    );


    cartDrawerRefreshTimer =
      setTimeout(
        async () => {

          try {

            /*
              نقرأ Cart الحقيقي
            */

            const cart =
              await getCart();


            /*
              تحديث Cart Icon
            */

            updateCartIconCount(
              cart.item_count
            );


            /*
              معرفة العنصر الحالي
            */

            const currentCartItems =
              document.getElementById(
                CONFIG.cartItemsId
              );


            /*
              إذا Shopify استبدلت العنصر
            */

            if (
              currentCartItems &&
              currentCartItems !==
                observedCartItems
            ) {

              observedCartItems =
                currentCartItems;
            }


            /*
              تحديث Recommendations
            */

            await loadCartDrawerRecommendations();


            /*
              إعادة ربط Observer
            */

            initCartItemsObserver();


          } catch (error) {

            console.error(
              'Cotton Hub cart refresh error:',
              error
            );

          }

        },

        350
      );
  }


  function initCartItemsObserver() {

    const cartDrawer =
      document.querySelector(
        'cart-drawer'
      );


    if (!cartDrawer) {
      return;
    }


    /*
      فصل Observer القديم
    */

    if (cartObserver) {

      cartObserver.disconnect();

      cartObserver = null;
    }


    /*
      العنصر الحالي
    */

    observedCartItems =
      document.getElementById(
        CONFIG.cartItemsId
      );


    /*
      نراقب الـCart Drawer كله
      وليس CartItems فقط.

      السبب:
      Shopify ممكن تستبدل
      CartDrawer-CartItems بالكامل.
    */

    cartObserver =
      new MutationObserver(
        mutations => {

          let cartChanged =
            false;


          mutations.forEach(
            mutation => {

              if (
                mutation.type !==
                'childList'
              ) {
                return;
              }


              if (
                mutation.addedNodes.length === 0 &&
                mutation.removedNodes.length === 0
              ) {
                return;
              }


              /*
                العنصر الحالي في الصفحة
              */

              const currentCartItems =
                document.getElementById(
                  CONFIG.cartItemsId
                );


              /*
                هل التغيير حصل
                داخل CartItems؟
              */

              const target =
                mutation.target;


              const targetInsideCart =
                target &&
                (
                  target.id ===
                    CONFIG.cartItemsId ||

                  target.closest?.(
                    `#${CONFIG.cartItemsId}`
                  )
                );


              /*
                هل CartItems نفسه
                اتغير / اتبدل؟
              */

              const cartItemsReplaced =
                currentCartItems &&
                currentCartItems !==
                  observedCartItems;


              /*
                هل تم حذف CartItems
                من DOM؟
              */

              let cartItemsRemoved =
                false;


              mutation.removedNodes.forEach(
                node => {

                  if (
                    node.nodeType !==
                    1
                  ) {
                    return;
                  }


                  if (
                    node.id ===
                    CONFIG.cartItemsId
                  ) {

                    cartItemsRemoved =
                      true;

                    return;
                  }


                  if (
                    node.querySelector?.(
                      `#${CONFIG.cartItemsId}`
                    )
                  ) {

                    cartItemsRemoved =
                      true;
                  }

                }
              );


              /*
                هل تم إضافة CartItems
              */

              let cartItemsAdded =
                false;


              mutation.addedNodes.forEach(
                node => {

                  if (
                    node.nodeType !==
                    1
                  ) {
                    return;
                  }


                  if (
                    node.id ===
                    CONFIG.cartItemsId
                  ) {

                    cartItemsAdded =
                      true;

                    return;
                  }


                  if (
                    node.querySelector?.(
                      `#${CONFIG.cartItemsId}`
                    )
                  ) {

                    cartItemsAdded =
                      true;
                  }

                }
              );


              /*
                أي تغيير حقيقي
                في محتوى السلة
              */

              if (
                targetInsideCart ||
                cartItemsReplaced ||
                cartItemsRemoved ||
                cartItemsAdded
              ) {

                cartChanged =
                  true;
              }

            }
          );


          if (cartChanged) {

            refreshRecommendationsAfterCartChange();
          }

        }
      );


    /*
      مراقبة Cart Drawer كله
    */

    cartObserver.observe(
      cartDrawer,
      {
        childList:
          true,

        subtree:
          true
      }
    );

  }


  /* =========================================================
     24. OBSERVE CART DRAWER OPEN/CLOSE
     ========================================================= */

  function initCartDrawerObserver() {

    const cartDrawer =
      document.querySelector(
        'cart-drawer'
      );


    /*
      لو الـDrawer لسه ما اتحملش
    */

    if (!cartDrawer) {

      setTimeout(
        initCartDrawerObserver,
        1000
      );

      return;
    }


    /*
      منع تهيئة مكررة
    */

    if (isInitialized) {

      initCartItemsObserver();

      return;
    }


    isInitialized =
      true;


    let drawerRefreshTimer = null;


    const drawerObserver =
      new MutationObserver(
        mutations => {

          let shouldRefresh =
            false;


          mutations.forEach(
            mutation => {

              if (
                mutation.type ===
                'attributes' &&
                (
                  mutation.attributeName ===
                    'class' ||

                  mutation.attributeName ===
                    'style' ||

                  mutation.attributeName ===
                    'open'
                )
              ) {

                shouldRefresh =
                  true;
              }

            }
          );


          if (!shouldRefresh) {
            return;
          }


          clearTimeout(
            drawerRefreshTimer
          );


          drawerRefreshTimer =
            setTimeout(
              () => {

                const visible =
                  cartDrawer.offsetParent !== null ||

                  cartDrawer.hasAttribute(
                    'open'
                  ) ||

                  cartDrawer.classList.contains(
                    'active'
                  ) ||

                  cartDrawer.classList.contains(
                    'is-open'
                  );


                if (visible) {

                  loadCartDrawerRecommendations();

                  initCartItemsObserver();
                }

              },

              150
            );

        }
      );


    drawerObserver.observe(
      cartDrawer,
      {
        attributes:
          true,

        attributeFilter: [
          'class',
          'style',
          'open'
        ]
      }
    );


    /*
      Initial load
    */

    loadCartDrawerRecommendations();


    /*
      Start robust cart observer
    */

    initCartItemsObserver();

  }


  /* =========================================================
     25. INITIALIZE
     ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initCartDrawerObserver,
      {
        once:
          true
      }
    );

  } else {

    initCartDrawerObserver();

  }


  /* =========================================================
     26. PUBLIC API
     ========================================================= */

  window.CottonHubCartRecommendations = {

    refresh:
      loadCartDrawerRecommendations,

    add:
      addRecommendedItem,

    updateCartIcon:
      updateCartIconCount

  };


})();